module.exports = __webpack_public_path__ + "img/ground-sea-day.4c976ace.png";